import PolygonBase from './PolygonBase';
import shapeIcon from '../assets/icons/shapeDocument.svg';
import { svgToIcon } from '../utils/svg';

const HEIGHT_FACTOR = 0.5;

class ShapeDocument extends PolygonBase {
  static renderIcon() {
    return svgToIcon(shapeIcon);
  }

  static defaultHeight() {
    return this.defaultWidth() * HEIGHT_FACTOR;
  }

  static pathString() {
    return `
      M0.0870 0.3055
      C-0.2 0.6 -0.4 0.5 -0.5 0.4
      V-0.5
      H0.5
      V0.3815
      C0.4193 0.2285 0.2044 0.1946 0.0870 0.3055
      Z
    `;
  }

  calcTextMargin() {
    const margins = super.calcTextMargin();
    margins.bottom += 20;
    return margins;
  }
}

export default ShapeDocument;
